module.exports = __webpack_public_path__ + "a0f04afd4755019e69b1345fbc87139e.svg";